export default function ArticleBody({ html }) {
  if (!html) {
    return (
      <p className="text-gray-400 italic py-16 text-center">
        No content available.
      </p>
    );
  }

  return (
    <div
      lang="en"
      className="prose prose-gray max-w-none break-words
        [&_h2]:scroll-mt-24 [&_h3]:scroll-mt-24
        prose-headings:font-semibold prose-headings:tracking-tight prose-headings:text-gray-900
        prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3
        prose-h3:text-lg prose-h3:mt-7 prose-h3:mb-2
        prose-p:text-[15px] prose-p:leading-7 prose-p:text-gray-600
        prose-li:text-[15px] prose-li:leading-7 prose-li:text-gray-600 prose-li:marker:text-[#9573F7]
        prose-a:text-[#9573F7] prose-a:no-underline hover:prose-a:underline
        prose-strong:text-gray-900
        prose-img:rounded-xl
        prose-blockquote:border-l-4 prose-blockquote:border-[#9573F7] prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
